// DOCS: This one liner statement will be used in loading fibo screens
const oneLinersStatementsArr = [
  'Indian Rupee is made of cotton and not paper',
  '₹5000 and ₹10000 rupees notes once existed in our country ',
  'There are total 15 languages on Indian currency',
  'Nepali is the only foreign language printed on Indian currency',
  'India has more people using the Internet than the entire population of the United States',
  'Do you know the first guidelines for KYC were introduced by the RBI in 2002',
  'Bank of Hindustan was first Indian bank launched in 1770',
  'The first person to be given Aadhaar identity number was from Maharashtra',
  'ICICI Bank was the first indian bank to introduce Net Banking facility',
  "The fifth character in PAN Card denotes first letter of PAN Holder's Surname",
  'The "₹" symbol  was designed by designer D Uday Kumar',
  'The first photo took 8 hours to expose',
  'QWERTY keyboard was designed to slow down the typing speed',
  "India is the world's largest consumer of gold",
  'There are 180 currencies circulating in 197 countries',
  'Refer Fibe to friends & family & win up to ₹300 cashback on their first loan',
  'It takes less than 10 minutes to complete your Fibe application & to transfer money in your bank account',
  "In 1969, the RBI released ₹1 notes with Mahatma Gandhi's photo appearing for the first time on Indian notes",
  'UPI is now accepted in 10 countries.',
];

export const getLoadingOneLiner = () => {
  const oneLinersArrLength = oneLinersStatementsArr.length;
  const randomIdx = Math.floor(oneLinersArrLength * Math.random());
  return `"${oneLinersStatementsArr[randomIdx]}"`;
};
